// Mutable ref set by NavigateSetter so api.js interceptors can call navigate()
// from outside React's component tree.
export const navRef = { current: null };
